import {config} from "../config";
import {handleResponse} from "../helpers/response";
import {preloadUserData} from "./checkout";


export const SET_USER_INFO = 'SET_USER_INFO';
export const SHOW_USER_LOADER = 'SHOW_USER_LOADER';
export const HIDE_USER_LOADER = 'HIDE_USER_LOADER';

export function getUsersInfo(){
    return (dispatch, getState) => {
        var link = config.apiUrl + 'api/user/info/';
        dispatch(showUserLoader());
        fetch(link).then(handleResponse).then(json => {
            dispatch(setUsersInfo(json));
            dispatch(preloadUserData(json));
            dispatch(hideUserLoader());
        })
    }
}

export function setUsersInfo(data){
    return {
        type: SET_USER_INFO,
        userInfo: data
    }    
}

export function showUserLoader(){
    return {
        type: SHOW_USER_LOADER
    }
}


export function hideUserLoader() {
    return {
        type: HIDE_USER_LOADER
    }
}